export default __webpack_public_path__ + "static/8-610b5ea6545bf0301ef440eb3de9458b.webp";